import TinyStore from 'lib/tinyStore';
import { EHomePopupKey } from 'constants/homePopups';

type HomePopupState = {
    eligibleMap: Partial<Record<EHomePopupKey, boolean>>;
    dismissedMap: Partial<Record<EHomePopupKey, boolean>>;
};

const Store = TinyStore.createStore<HomePopupState>({
    nameSpace: 'klarity',
    key: 'home_popup',
    crossBundle: false,
    runTime: true,
    initValue: {
        eligibleMap: {},
        dismissedMap: {},
    },
});

export default Store;
